import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import EventsTable from "../Events/EventsTable";

const COPY = {
  title: "Manage Events",
  subtitle: "You Can View Edit & Delete Verified Events",
  searchPlaceholder: "Search Here",
};

const EventsAdmin = () => {
  const { items, loading, searchValue, setSearchValue } =
    useAdminList("getEvents");

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <EventsTable driverData={items} />
    </AdminPage>
  );
};

export default EventsAdmin;
